import React from 'react';
import { Modal } from 'antd';
import './ImagePreviewModal.scss';

const ImagePreviewModal = ({ visible, imageUrl, title, onClose }) => {
  if (!imageUrl) return null;

  return (
    <Modal
      title={title || 'Image preview'}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      wrapClassName="sl-image-preview-modal"
      destroyOnClose
      style={{ top: 24 }}
      bodyStyle={{ padding: '12px 24px 24px', textAlign: 'center' }}
    >
      <div className="sl-image-preview-body">
        <img src={imageUrl} alt={title || 'Space preview'} className="sl-image-preview-img" />
      </div>
    </Modal>
  );
};

export default ImagePreviewModal;
